export function otherSlot(slot) {
    return slot === 0 ? 1 : 0;
}
//# sourceMappingURL=types.js.map